/**
 * Created by zad on 17/4/25.
 */
import { NoteHistory } from '../constants/actionTypes';
import createAction from '../utils/createAction';

// eslint-disable-next-line import/prefer-default-export
export const resetNoteHistory = createAction(NoteHistory.NOTE_HISTORY_INIT); // 重置NoteHistory数据

export const getNoteHistoryList = createAction(NoteHistory.GET_NOTE_HISTORY_LIST, 'noteId');

export const getNoteHistoryContent = createAction(NoteHistory.GET_NOTE_HISTORY_CONTENT, 'historyId', 'noteId');

export const restoreNoteHistoryContent = createAction(NoteHistory.RESTORE_NOTE_HISTORY_CONTENT, 'nbId', 'noteId', 'historyId');



// WEBPACK FOOTER //
// ./src/actions/NoteHistoryAction.js